/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { UserByRightDto } from '../../models/user-by-right-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetUsersByRightName$Params {
  rightName: string;
}

export function getUsersByRightName(
  http: HttpClient,
  rootUrl: string,
  params: GetUsersByRightName$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<UserByRightDto>>> {
  const rb = new RequestBuilder(rootUrl, getUsersByRightName.PATH, 'get');
  if (params) {
    rb.path('rightName', params.rightName, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserByRightDto>>;
    }),
  );
}

getUsersByRightName.PATH = '/service/v1/user/usersByRightName/{rightName}';
